import { render, staticRenderFns } from "./LogBatchComponent.vue?vue&type=template&id=7837bdb2"
import script from "./LogBatchComponent.vue?vue&type=script&lang=js"
export * from "./LogBatchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports